module.exports = __webpack_public_path__ + "static/img/pdf.eabdda6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/public/pdf.png
// module id = Nm9k
// module chunks = 3